import axios from 'axios';
import type { QueuePreferences } from 'Router/pages/AnsweringPages/AnsweringQueue/types';

const saveQueuePreferences = async (preferences: QueuePreferences) => {
  const { data } = await axios.post(
    '/answering/queue_preferences',
    preferences,
  );
  return data;
};

export default saveQueuePreferences;
